// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3M_Ax","title":"ClientReferral_title__1EOqH","itemText":"ClientReferral_itemText__3o_70"};